import { useInfiniteQuery } from "react-query"
import { ShowCustomRepairTimeListsRequest } from "../models"
import { showCustomRepairTimeLists } from "../showCustomRepairTimeLists"
import { QUERY_KEY_REPAIRTIME_LISTS } from "./keys"

export function useShowCustomRepairTimeLists(request: Omit<ShowCustomRepairTimeListsRequest, "pageIndex" | "pageSize">) {
    const queryKey = [QUERY_KEY_REPAIRTIME_LISTS, request.listNameQuery || undefined, request.repairTimeQuery || undefined]
    return useInfiniteQuery(queryKey, async ({ pageParam = 1 }) => showCustomRepairTimeLists({ ...request, pageIndex: pageParam, pageSize: 50 }), {
        getNextPageParam: (lastPage) => {
            if (!lastPage.endOfList) {
                return lastPage.pageIndex + 1
            }
        },
        enabled: true,
    })
}
